import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import page components
import Home from './PageComponents/Home';
import HotelReviews from './PageComponents/HotelReviews';
import LuxuryHotels from './PageComponents/LuxuryHotels';
import BoutiqueHotels from './PageComponents/BoutiqueHotels';
import EcoFriendlyHotels from './PageComponents/EcoFriendlyHotels';
import BudgetHotels from './PageComponents/BudgetHotels';
import CasinoHotels from './PageComponents/CasinoHotels';
import AboutUs from './PageComponents/AboutUs';
import ContactUs from './PageComponents/ContactUs';
import PrivacyPolicy from './PageComponents/PrivacyPolicy';
import TermsAndConditions from './PageComponents/TermsAndConditions';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/review-hotel" element={<HotelReviews />} />
      <Route path="/luxury-hotel" element={<LuxuryHotels />} />
      <Route path="/boutique-hotel" element={<BoutiqueHotels />} />
      <Route path="/eco-friendly-hotels" element={<EcoFriendlyHotels />} />
      <Route path="/budget-hotels" element={<BudgetHotels />} />
      <Route path="/casino-hotel" element={<CasinoHotels />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
    </Routes>
  );
};

export default AppRoutes;